import { render, staticRenderFns } from "./FreestyleThumbnailPreview.vue?vue&type=template&id=2a0ba20b&scoped=true&"
import script from "./FreestyleThumbnailPreview.vue?vue&type=script&lang=js&"
export * from "./FreestyleThumbnailPreview.vue?vue&type=script&lang=js&"
import style0 from "./FreestyleThumbnailPreview.vue?vue&type=style&index=0&id=2a0ba20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ba20b",
  null
  
)

export default component.exports